import React, { useId } from "react";
import { FiX, FiAlertTriangle } from "react-icons/fi";
import "../../../views/app/productCategories/AddProductCategoryModal.scss";
import "./modals.scss";
import styles from "./ConfirmationModal.module.css";

interface ConfirmationModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: "danger" | "warning" | "primary";
  className?: string;
  isProcessing?: boolean;
  closeOnConfirm?: boolean;
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  show,
  onHide,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "danger",
  className = "",
  isProcessing = false,
  closeOnConfirm = true,
}) => {
  const titleId = useId();
  const messageId = useId();
  const handleConfirm = () => {
    if (isProcessing) return;
    onConfirm();
    if (closeOnConfirm) onHide();
  };

  if (!show) return null;

  const getIconColor = () => {
    switch (variant) {
      case "danger":
        return "#EC3237";
      case "warning":
        return "#FFA500";
      case "primary":
        return "#00A759";
      default:
        return "#EC3237";
    }
  };

  const getConfirmButtonClass = () => {
    switch (variant) {
      case "danger":
        return styles.confirmButtonDanger;
      case "warning":
        return styles.confirmButtonWarning;
      case "primary":
        return styles.confirmButtonPrimary;
      default:
        return styles.confirmButtonDanger;
    }
  };

  return (
    <div className={`modal-overlay ${className}`}>
      <div className="modal-container" role="dialog" aria-modal="true" aria-labelledby={titleId} aria-describedby={messageId}>
        <div className="modal-header">
          <div className={styles.headerContainer}>
            <FiAlertTriangle size={24} color={getIconColor()} />
            <h2 id={titleId}>{title}</h2>
          </div>
          <button type="button" className={styles.closeButton} onClick={onHide} disabled={isProcessing} aria-label="Close dialog">
            <FiX aria-hidden="true" />
          </button>
        </div>
        <div className="modal-form">
          <p id={messageId} className={styles.message}>{message}</p>
          <div className={styles.buttonContainer}>
            <button
              type="button"
              onClick={onHide}
              className={styles.cancelButton}
              disabled={isProcessing}
            >
              {cancelText}
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              className={`${styles.confirmButton} ${getConfirmButtonClass()}`}
              disabled={isProcessing}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
